export default __webpack_public_path__ + "static/anonymous-ee37dbd5dbb12c09b006f09fe173c96f.png";